import type { ComponentProps, ReactNode } from 'react';
import { cn } from './cn';
import { focusRing } from './focus';

/** A large pressable tile, its art above its label (the tools of the phone's "+" sheet); pressed = the active tool. */
export function ToolTile({ label, art, pressed, className, ...rest }: Omit<ComponentProps<'button'>, 'children'> & { label: string; art: ReactNode; pressed?: boolean }) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      className={cn(
        'flex min-h-[4.5rem] flex-col items-center justify-center gap-1 rounded-2xl bg-surface-2 px-1 text-center font-sans text-xs text-fg os-press aria-pressed:bg-accent-soft aria-pressed:text-fg aria-pressed:ring-1 aria-pressed:ring-accent',
        focusRing,
        className,
      )}
      {...rest}
    >
      {art}
      <span className="line-clamp-2">{label}</span>
    </button>
  );
}
